import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  login: string;
  fullName: string;
  whid: string;
  managerLogin: string;
  managerName: string;
}

const initialState: UserState = {
  login: '',
  fullName: '',
  whid: '',
  managerLogin: '',
  managerName: ''
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<Partial<UserState>>) => {
      console.log('User reducer called with action:', 'setUser', action.payload); // Debug log
      Object.assign(state, action.payload);
      console.log('User state updated:', state); // Debug log
    }
  }
});

export const { setUser } = userSlice.actions;
export default userSlice.reducer;
